/**
* @summary - Component that Provides RI functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeIcon from "@mui/icons-material/Home";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  IconButton,
  Typography
} from "@mui/material";
import Tab from '@mui/material/Tab';
import React, { useState } from 'react';
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import RoutineInspectionCreate from './RoutineInspectionCreate';
import RoutineInspectionShowSchedule from './RoutineInspectionShowSchedule';
import {getFacilityId,getcompanyId} from '../../utility/tokenUtility'
import PageTitle from "../commoncomponents/PageTitle";
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository";
import RoutineInspectionRepository from "../../api/repositories/routineInspectionRepository"
function RoutineInspectionMain() {
  const [value, setValue] = useState('1');
  const[year,setYear]=useState();
  const [serviceType,setServiceType] = useState();
  const [routineId,setRIId] = useState();
const [assetNo,setAssetNo]=useState();
const [taskCode,setTaskCode]=useState();
const [mode,setMode]=useState();
const [periodForShowSchedule,setPeriodForShowSchedule]=useState();
const [changeHeaderAndButtonName,setChangeHeaderAndButtonName]=useState(false);
const[assetNoForShowSchedule,setAssetNoForShowSchedule]=useState();
const[locationCodeForShowSchedule,setLocationCodeForShowSchedule]=useState();
const[locationDescForShowSchedule,setLocationDescForShowSchedule]=useState();

  const facilityId= getFacilityId();
  const companyId=getcompanyId();
    const handleChange = async(event, newValue) => {
   if(mode==='create' || mode==='edit' && routineId != undefined && newValue==1){
    let rowData;
    if(mode==='create'){
      setChangeHeaderAndButtonName(true);
    }
    if(routineId!=undefined){
    if (serviceType?.label === 'FEMS') {
    const rowDatas=await RoutineInspectionRepository.getRIListForExport(facilityId);
    rowData=rowDatas?.data?.find((item)=>item?.id===routineId)
    } else  if(serviceType?.label === 'BEMS'){
      const rowDatas=await RoutineInspectionRepository.getBemsRIListForExport(facilityId);
      rowData=rowDatas?.data?.find((item)=>item?.id===routineId)
    }
    if(rowData!=undefined){
    navigate("/routineInspection/register", {
      state: { ...rowData, readOnlyEdit: true, mode: "edit", service: serviceType?.label, changeHeaderAndButtonName:mode==='edit'?false:true },
    });
  }}else{
    setValue(newValue);
  }
   }
    setValue(newValue);
  };
  const navigate = useNavigate();
  const handleHomeClick = () => {
    navigate('/dashboard'); // Adjust the path as needed
  };
  return (
    <>
      <BreadcrumbBar>
        <Box sx={{ display: "inline-flex", gap: 1.25, alignItems: "center" }}>
        <PageTitle
           // title={"Create PPM Check List"}
            isEdit={mode === "edit"}
            isView={mode === "view"}
            editTitle={changeHeaderAndButtonName?"Create Routine Inspection":"Edit Routine Inspection"}
            viewTitle={"View Routine Inspection"}
            title={"Create Routine Inspection"} />
        </Box>       
      </BreadcrumbBar>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="asset-record" variant="scrollable" scrollButtons="auto">
            <Tab label="Routine Inspection" value="1" />
            <Tab label="Show the Schedule" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <RoutineInspectionCreate 
          routineId={routineId} 
          assetNoForShowSchedule={(item)=>setAssetNo(item)} 
          taskCodeForShowSchedule={(item)=>{setTaskCode(item)}} 
          companyId ={companyId} 
          facilityId={facilityId} 
          handleServiceType={(item)=>setServiceType(item)}
          setRIId={(item)=>setRIId(item)} 
          selectedYear={(item)=>setYear(item)} 
          selectedServiceType={serviceType} 
          getMode={(item)=>setMode(item)} 
          setPeriodForShowSchedule={(item)=>setPeriodForShowSchedule(item)}
          setAssetNoForShowSchedule={(item)=>setAssetNoForShowSchedule(item)}
          setLocationCodeForShowSchedule={(item)=>setLocationCodeForShowSchedule(item)}
          setLocationDescForShowSchedule={(item)=>setLocationDescForShowSchedule(item)}
          />
          
        </TabPanel>
        <TabPanel value="2">
          <RoutineInspectionShowSchedule 
          assetdeatils={assetNo} 
          taskCode={taskCode} 
          routineId={routineId} 
          companyId ={companyId} 
          facilityId={facilityId}  
          year={year} 
          serviceType={serviceType}
          periodForShowSchedule={periodForShowSchedule}
          assetNoForShowSchedule={assetNoForShowSchedule}
          locationCodeForShowSchedule={locationCodeForShowSchedule}
          locationDescForShowSchedule={locationDescForShowSchedule}
          />
        </TabPanel>
      </TabContext>
    </>
  );
}

export default RoutineInspectionMain;
